<template>
  <span>
    <v-tooltip bottom>
        <span slot="activator">
          <v-btn @click.stop.prevent="handleShowForm" icon small>
            <v-icon small>fa-envelope</v-icon>
          </v-btn>
        </span>
      Edit client invoice email
    </v-tooltip>

    <v-dialog max-width="800" persistent v-model="showModal">
      <with-metadata :id="clientId" @loaded="handleMetadataLoaded" table="clients"
                     v-if="showModal">
          <template slot="default" slot-scope="{metadata}">
            <v-card>
              <v-card-title class="headline">Client invoice email</v-card-title>

                <v-card-text>
                  <v-form ref="form" v-model="isValid">
                      <v-text-field
                        :rules="emailRules"
                        label="Email"
                        v-model="form.email"
                      />

                      <v-text-field
                        label="Agreement"
                        v-model="form.agreementText"
                      />
                  </v-form>
                </v-card-text>

                <v-card-actions>
                  <v-spacer/>
                  <v-btn @click="handleHideForm">Cancel</v-btn>
                  <v-btn :disabled="!isSubmitEnabled"
                         :loading="requestInProgress"
                         @click="handleFormSubmit">Edit</v-btn>
                </v-card-actions>
              </v-card>
        </template>
      </with-metadata>
    </v-dialog>
  </span>
</template>

<script>
  import WithMetadata from '../Ui/mcc/WithMetadata'
  import {mapActions} from "vuex";
  import {notificationService} from "../../application";
  import _ from "lodash";
  import {validateStringLength} from "../../helpers/validation";

  function getDefaultFormData() {
    return {
      email: null,
      agreementText: null
    }
  }

  export default {
    name: 'edit-client-invoice-email-form',
    components: {
      WithMetadata
    },
    props: {
      clientId: {
        type: String,
        required: true,
      }
    },
    data() {
      return {
        form: getDefaultFormData(),
        showModal: false,
        isValid: false,
        requestInProgress: false,
        emailRules: [ // todo(egor): move to common
          _.partial(validateStringLength, _, 1000, 'The length of the email should be no more than 1000 characters'),
          function (value) {
            if (!value) {
              return true
            }

            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            const emails = value.split(",");
            for (let email of emails) {
              if (!pattern.test(email.trim())) {
                return 'Invalid e-mail.'
              }
            }

            return true
          }
        ]
      }
    },
    watch: {
      showModal() {
        if (!this.showModal) {
          this.resetForm()
        }
      }
    },
    computed: {
      isSubmitEnabled() {
        if (!this.isValid) {
          return false
        }
        if (this.$refs.form && !this.$refs.form.validate()) {
          return false
        }

        return true
      },
    },
    methods: {
      ...mapActions({
        clientUpdateInvoiceEmail: 'clientUpdateInvoiceEmail',
      }),
      handleShowForm() {
        this.showModal = true
      },
      handleHideForm() {
        this.showModal = false
      },
      handleFormSubmit() {
        if (!this.isSubmitEnabled) {
          return
        }

        const request = {
          clientId: this.clientId,
          email: this.form.email,
          agreementText: this.form.agreementText,
        };

        this.requestInProgress = true;

        this
          .clientUpdateInvoiceEmail(request)
          .then(() => {
            this.requestInProgress = false;
            notificationService.info('Operation success');
            this.resetForm();
            this.showModal = false
          })
          .catch(e => {
            this.requestInProgress = false;
            notificationService.error('Operation failed');
            throw e
          })
      },
      resetForm() {
        this.form = getDefaultFormData(this.caseInfo)
      },
      handleMetadataLoaded(metadata) {
        if (metadata && metadata.invoiceEmail) {
          this.form.email = metadata.invoiceEmail
        }

        if (metadata && metadata.invoiceEmail) {
          this.form.agreementText = metadata.agreementText
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/clients/EditClientInvoiceEmailForm.vue